import {hashHistory} from "react-router";

import {
  POPUP_IN_PROGRESS,
  VISUALIZER_MANAGEMENT_REQUEST,
  VISUALIZER_MANAGEMENT_UPDATE_REQUEST,
  VISUALIZER_MANAGEMENT_SUCCESS,
  VISUALIZER_MANAGEMENT_CHANGES_SAVING,
  VISUALIZER_MANAGEMENT_CHANGES_SAVED,
  VISUALIZER_MANAGEMENT_UPDATE_DELETE_LIST,
  VISUALIZER_MANAGEMENT_DEFAULTS_REQUEST,
  VISUALIZER_MANAGEMENT_DEFAULTS_SUCCESS,
  VISUALIZER_MANAGEMENT_GET_DEFAULTS,
  VISUALIZER_MANAGEMENT_SET_DEFAULTS,
  VISUALIZER_MANAGEMENT_POST_DEFAULTS,
  VISUALIZER_MANAGEMENT_SET_ACTIVE_DEFAULT_PRESET_INDEX,
  VISUALIZER_MANAGEMENT_SET_ACTIVE_TAB,
  VISUALIZER_MANAGEMENT_SET_PRODUCT_JOURNEY, VISUALIZER_MANAGEMENT_SET_PRESETS_RECEIVED
} from '../../constants/actionTypes';

import {getApiConfig} from '../../utilities/index';

import {errorBox_Show, loadingDialog_show, toggle_modal} from "../../actions/A_Popups";
import {messageBox_Show} from "../../actions";
import {VISUALIZER_TYPES} from "../../constants/dashboard";
import {IS_LIXIL_SERVERS} from "../../utilities/backend";

/* presets CONSTANTS */
export const getPresetsName = (forTool = VISUALIZER_TYPES.bathroom) => {

  // console.log("forTool", forTool);
  switch (forTool) {
    case VISUALIZER_TYPES.bathroom:
    default:
      return {
        presetName: "defaultBvPresets",
        indexName: "activeDefaultBvPresetIndex",
        visualizerName: "bathroomvisualizer",
        mobileLinks: "mobileBVMenu",
      };
    case VISUALIZER_TYPES.kitchen:
      return {
        presetName: "defaultKvPresets",
        indexName: "activeDefaultKvPresetIndex",
        visualizerName: "kitchenvisualizer",
        mobileLinks: "mobileMenu",
      };
    case VISUALIZER_TYPES.fireplace:
      return {
        presetName: "defaultFpPresets",
        indexName: "activeDefaultFpPresetIndex",
        visualizerName: "fireplacevisualizer",
        mobileLinks: "mobileFpMenu",
      };
    case VISUALIZER_TYPES.laundryroom:
      return {
        presetName: "defaultLrPresets",
        indexName: "activeDefaultLrPresetIndex",
        visualizerName: "laundryroomvisualizer",
        mobileLinks: "mobileLrMenu",
      };
  }
};
/* presets CONSTANTS end */

export const getVisualizerManagementMenu = () => {
  return (dispatch, getState) => {

    const {auth, asCustomer} = getState();

    dispatch({type: VISUALIZER_MANAGEMENT_REQUEST});

    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    getApiConfig('FabricatorVisualizerNavigation/List').get("?FabricatorId=" + fabricatorId)
      .then((response) => {
        console.log('response getVisualizerManagementMethod->', response);
        dispatch({
          type: VISUALIZER_MANAGEMENT_SUCCESS,
          payload: response
        })
      });
  }
};

export const updateVisualizerManagement = (mobileMenu, forTool) => {
  return {
    type: VISUALIZER_MANAGEMENT_UPDATE_REQUEST,
    payload: {forTool, mobileMenu}
  };
};

export const cancelVisualizerManagementChanges = () => {
  return dispatch => {
    dispatch(messageBox_Show(true, 'system', 'Cancel', 'Are you sure you want to cancel your last changes?',
      [{
        text: 'Cancel',
        onClick: () => {
          dispatch(messageBox_Show());
        }
      }, {
        text: 'Yes',
        color: "green",
        onClick: () => {
          dispatch(messageBox_Show());
          hashHistory.push('/');
          // dispatch(getVisualizerManagementMenu());
          // dispatch(getDefaultPresets());
        }
      }]));
  }
};

export const updateDeleteList = (menuItem) => {
  if (menuItem.id && menuItem.id.length > 0) {
    return {type: VISUALIZER_MANAGEMENT_UPDATE_DELETE_LIST, payload: menuItem};
  } else {
    return {type: null};
  }
};

export const saveVisualizerManagement = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {mobileMenu, mobileBVMenu} = state.visualizerManagement;
    const {asCustomer, auth} = state;
    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

    [mobileMenu, mobileBVMenu].forEach(menu => {
      // make a validation against empty fields.
      for (let i = 0; i < menu.length; i++) {
        const {name, url} = menu[i];
        if (name.trim().length === 0 || url.trim().length === 0) {
          dispatch(errorBox_Show({
            title: 'Error',
            text: 'URL and name must have a value.',
            rightButtonText: 'OK',
            isRightButtonVisible: true
          }));
          return;
        }
      }

      dispatch({
        type: POPUP_IN_PROGRESS,
        payload: {
          show: true,
          title: 'Saving...',
          message: 'Please wait while we are storing your changes.'
        }
      });


      dispatch({type: VISUALIZER_MANAGEMENT_CHANGES_SAVING});
      let p = [];
      let d = [];
      for (let n = 0; n < state.visualizerManagement.delete.length; n++) {
        let data = state.visualizerManagement.delete[n];
        d.push(new Promise((resolve, reject) => {
          getApiConfig('FabricatorVisualizerNavigation/Delete').post(data)
            .then(response => {
              // console.log('response postVisualizerManagementDeleteMethod ->', response);
              resolve(response);
            }).catch(reject);
        }));
      }
      Promise.all(d).then(() => {
        for (let i = 0; i < menu.length; i++) {
          let data = menu[i];
          let action = 'Create';

          if (data.id) {
            const existingIndex = state.visualizerManagement.initialLoaded.findIndex((link) => {
              return link.id === data.id
            });
            if (existingIndex > -1) {
              action = 'Edit';
            }
          }

          data.displayOrder = i;
          p.push(new Promise((resolve, reject) => {
            getApiConfig('FabricatorVisualizerNavigation/' + action).post(data)
              .then(response => {

                // console.log('response postVisualizerManagementMethod ->', response);

                dispatch({
                  type: POPUP_IN_PROGRESS,
                  payload: {
                    show: false
                  }
                });

                if (action === 'Create') {
                  data.id = response;
                }

                return data;
              }).then(resolve).catch(reject);
          }));
        }
        Promise.all(p).then((data) => {
          dispatch({type: VISUALIZER_MANAGEMENT_CHANGES_SAVED, payload: data});
        }).then(() =>
          dispatch({
            type: POPUP_IN_PROGRESS,
            payload: {
              show: false
            }
          })
        )
      });
    });
  }
};

export const setActiveDefaultPresetIndex = (activeDefaultPresetIndex, forTool) => {
  const {indexName} = getPresetsName(forTool);
  return {
    type: VISUALIZER_MANAGEMENT_SET_ACTIVE_DEFAULT_PRESET_INDEX,
    payload: {
      [indexName]: activeDefaultPresetIndex
    }
  };
};

export const getDefaultPresets = () => {
  return (dispatch, getState) => {

    const {auth, asCustomer} = getState();
    const fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

    dispatch({type: VISUALIZER_MANAGEMENT_DEFAULTS_REQUEST});

    Promise.all([
      getApiConfig('public/getDefaults/').get(`${fabricatorId}/client/bathroomvisualizer`),
      getApiConfig('public/getDefaults/').get(`${fabricatorId}/client/kitchenvisualizer`),
      getApiConfig('public/getDefaults/').get(`${fabricatorId}/client/fireplacevisualizer`),
      getApiConfig('public/getDefaults/').get(`${fabricatorId}/client/laundryroomvisualizer`),
      getApiConfig(`Users/GetCustomerInfo/${fabricatorId}/Fabricator/undefined`).get()
    ])
      .then((responseArray) => {
        const bvResponse = (JSON.parse(responseArray[0]) || []).map(preset => {
          if (responseArray[3] && responseArray[3].bV_Version) {
            preset.version = responseArray[3].bV_Version
          } else if (responseArray[3] && responseArray[3].toolSettings && responseArray[3].toolSettings
            && responseArray[3].toolSettings["bathroom"] && responseArray[3].toolSettings["bathroom"].version) {
            preset.version = responseArray[3].toolSettings["bathroom"].version;
          }
          if (!IS_LIXIL_SERVERS) {
            return preset
          }
          const subDomain = ((asCustomer && asCustomer.activeEntity ? asCustomer.activeEntity.subDomain : auth.subDomain) || "").toLowerCase();
          if (preset.roomType === "americanstandard" || !subDomain.includes("grohe")) {
            if (preset.roomType === "grohe" || !preset.roomType) {
              preset.layout_type = preset.layout_type > 10
                ? preset.layout_type - 10
                : preset.layout_type;
            } else {
              preset.layout_type = preset.layout_type > 20
                ? preset.layout_type - 10
                : preset.layout_type < 10
                  ? preset.layout_type + 10
                  : preset.layout_type;
            }
          }
          return preset
        });
        const kvResponse = JSON.parse(responseArray[1]);
        const fpResponse = JSON.parse(responseArray[2]);
        const lrResponse = JSON.parse(responseArray[3]);
        console.log('bvResponse->', bvResponse);
        console.log('kvResponse->', kvResponse);
        console.log('fpResponse->', fpResponse);
        console.log('lrResponse->', lrResponse);
        const defaultBvPresets = bvResponse && bvResponse.length ? [...bvResponse] : [{}];
        const defaultKvPresets = kvResponse && kvResponse.length ? [...kvResponse] : [{}];
        const defaultFpPresets = fpResponse && fpResponse.length ? [...fpResponse] : [{}];
        const defaultLrPresets = lrResponse && lrResponse.length ? [...lrResponse] : [{}];
        const activeDefaultBvPresetIndex = defaultBvPresets.findIndex(preset => preset.loadByTheDefault) > -1
          ? defaultBvPresets.findIndex(preset => preset.loadByTheDefault) : 0;
        const activeDefaultKvPresetIndex = defaultKvPresets.findIndex(preset => preset.loadByTheDefault) > -1
          ? defaultKvPresets.findIndex(preset => preset.loadByTheDefault) : 0;
        const activeDefaultFpPresetIndex = defaultFpPresets.findIndex(preset => preset.loadByTheDefault) > -1
          ? defaultFpPresets.findIndex(preset => preset.loadByTheDefault) : 0;
        const activeDefaultLrPresetIndex = defaultLrPresets.findIndex(preset => preset.loadByTheDefault) > -1
          ? defaultLrPresets.findIndex(preset => preset.loadByTheDefault) : 0;
        dispatch({
          type: VISUALIZER_MANAGEMENT_GET_DEFAULTS,
          payload: {
            presetsReceived: true,
            defaultBvPresets,
            defaultKvPresets,
            defaultFpPresets,
            defaultLrPresets,
            activeDefaultBvPresetIndex,
            activeDefaultKvPresetIndex,
            activeDefaultFpPresetIndex,
            activeDefaultLrPresetIndex,
          }
        });
        dispatch({
          type: VISUALIZER_MANAGEMENT_DEFAULTS_SUCCESS,
          payload: {}
        })
      });
  }
};

export const setDefaultPresets = (presets, forTool = VISUALIZER_TYPES.bathroom) => {
  const {presetName} = getPresetsName(forTool);
  return (dispatch, getState) => {
    dispatch({
      type: VISUALIZER_MANAGEMENT_SET_DEFAULTS,
      payload: {
        [presetName]: presets
      }
    });
  }
};

export const postDefaultPresets = (presets, deleting, forTool = VISUALIZER_TYPES.bathroom, callback) => {
  return (dispatch, getState) => {

    const {auth, asCustomer} = getState();
    const fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

    dispatch({type: VISUALIZER_MANAGEMENT_DEFAULTS_REQUEST});

    dispatch({
      type: POPUP_IN_PROGRESS,
      payload: {
        show: true,
        title: deleting ? 'Deleting...' : 'Saving...',
        message: deleting ? 'Please wait while we are updating your changes.' : 'Please wait while we are storing your changes.'
      }
    });

    const {presetName, visualizerName} = getPresetsName(forTool);

    dispatch({
      type: VISUALIZER_MANAGEMENT_POST_DEFAULTS,
      payload: {
        [presetName]: presets,
      }
    });

    // console.log('presets to post', presets);

    getApiConfig(`public/saveDefaults/${fabricatorId}/client/${visualizerName}`).post(presets)
      .then((response) => {
        // console.log('response', response);
        dispatch({
          type: VISUALIZER_MANAGEMENT_DEFAULTS_SUCCESS
        });
        dispatch({
          type: POPUP_IN_PROGRESS,
          payload: {
            show: false
          }
        });
        if (!deleting) {
          dispatch(toggle_modal(true, "Preset successfully saved"));
        }
        if (callback) {
          callback()
        }
      })
      .catch((error) => {
        dispatch({
          type: POPUP_IN_PROGRESS,
          payload: {
            show: false
          }
        });
        dispatch(toggle_modal(true, error));
      });
  }
};

export const setActiveTab = (activeTab) => ({
  type: VISUALIZER_MANAGEMENT_SET_ACTIVE_TAB,
  payload: {activeTab}
});

export const setProductJourney = (isProductJourney) => ({
  type: VISUALIZER_MANAGEMENT_SET_PRODUCT_JOURNEY,
  payload: {isProductJourney}
});

export const setPresetsReceived = (presetsReceived) => ({
  type: VISUALIZER_MANAGEMENT_SET_PRESETS_RECEIVED,
  payload: {presetsReceived}
});
